import { apiSlice } from '../api/apiSlice'
import {
  PLATFORM_COST_MESSAGE,
  PLATFORM_COST_METRICS_API_PATH,
} from './platform-cost-metrics.constant'
import { isPlatformCostMetricsEnvelope } from './platform-cost-metrics.helpers'
import type {
  PlatformCostMetricsData,
  PlatformCostMetricsQueryArgs,
} from './platform-cost-metrics.type'

export const platformCostMetricsApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPlatformCostMetrics: builder.query<
      PlatformCostMetricsData,
      PlatformCostMetricsQueryArgs
    >({
      /**
       * Loads totals and zero-filled Africa/Lagos buckets for the selected range.
       */
      async queryFn(queryArgs, _api, _extraOptions, fetchWithBaseQuery) {
        const response = await fetchWithBaseQuery({
          url: PLATFORM_COST_METRICS_API_PATH,
          method: 'GET',
          params: queryArgs,
        })
        if (response.error !== undefined) return { error: response.error }

        const responseData: unknown = response.data
        if (!isPlatformCostMetricsEnvelope(responseData)) {
          return {
            error: {
              status: 'PARSING_ERROR',
              originalStatus: 200,
              data: responseData,
              error: PLATFORM_COST_MESSAGE.LOAD_ERROR,
            },
          }
        }

        return { data: responseData.data }
      },
      providesTags: ['PLATFORM_COST'],
    }),
  }),
})

export const { useGetPlatformCostMetricsQuery } = platformCostMetricsApiSlice
